import React from "react";

const DataCard = ({ heading, subHeading }) => {
  return (
    <div className="bg-surface-light flex flex-col justify-center items-center text-center gap-2 rounded-xl  p-12">
      <h1 className="text-5xl font-semibold">{heading}</h1>
      <p className="text-gray-700 text-2xl">{subHeading}</p>
    </div>
  );
};

export default DataCard;
